import { useCallback, useEffect, useState } from 'react';

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
        isMobileSize: document.documentElement.clientWidth <= 1000,
    });

    const changeWindowSize = useCallback(() => {
        setWindowSize({
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight,
            isMobileSize: document.documentElement.clientWidth <= 1000,
        });
    }, []);

    useEffect(() => {
        window.addEventListener('resize', changeWindowSize);

        return () => {
            window.removeEventListener('resize', changeWindowSize);
        };
    }, [changeWindowSize]);

    return windowSize;
};
